<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Crown, LockKeyhole } from 'lucide-vue-next';

const props = withDefaults(defineProps<{
    title: string;
    description: string;
    requirement?: string;
    compact?: boolean;
}>(), {
    requirement: 'Upgrade required',
    compact: false,
});

const { tenantPath } = useTenantPath();
const upgradeHref = computed(() => tenantPath('/settings/subscription'));
</script>

<template>
    <div
        :class="[
            'rounded-2xl border border-dashed border-border/80 bg-card/80 shadow-sm',
            compact ? 'p-4' : 'p-6',
        ]"
    >
        <div class="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
            <div class="space-y-3">
                <div class="flex flex-wrap items-center gap-2">
                    <Badge variant="outline" class="gap-1.5">
                        <LockKeyhole class="size-3.5" />
                        Premium feature
                    </Badge>
                    <Badge variant="secondary">{{ requirement }}</Badge>
                </div>
                <div class="space-y-1">
                    <h3 class="text-base font-semibold text-foreground">{{ title }}</h3>
                    <p class="max-w-2xl text-sm text-muted-foreground">{{ description }}</p>
                </div>
            </div>

            <Button as-child variant="outline" class="shrink-0">
                <NuxtLink :to="upgradeHref">
                    <Crown class="size-4" />
                    View plans
                </NuxtLink>
            </Button>
        </div>
    </div>
</template>
